import {RootState} from "../features/store";
import FormGroup from "@material-ui/core/FormGroup";
import Switch from "@material-ui/core/Switch";
import {makeStyles, createStyles, Theme, Grid} from "@material-ui/core";
import {switchCheckedAction} from "../features/sliceReducer/projectListReducer";
import {useDispatch, useSelector} from "react-redux";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    switchOn: {
      color: theme.palette.info.main,
      fontSize: "15px",
      fontWeight: "bold",
    },
    switchOff: {
      color: theme.palette.info.dark,
      fontSize: "15px",
      fontWeigh: "normal",
    },
  })
);

const SwitchControl = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {switchChecked} = useSelector((state: RootState) => state.projectList);

  const handleChange = () => {
    dispatch(switchCheckedAction());
  };

  return (
    <FormGroup row>
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid className={switchChecked ? classes.switchOff : classes.switchOn} item>
          내 프로젝트
        </Grid>
        <Grid item>
          <Switch checked={switchChecked} onChange={handleChange} name="checked" color="primary" />
        </Grid>
        <Grid className={switchChecked ? classes.switchOn : classes.switchOff} item>
          전체 프로젝트
        </Grid>
      </Grid>
    </FormGroup>
  );
};
export default SwitchControl;
